import { useEffect, useState } from 'react';

import { api } from '../../../services/api';
import { TimeLineDataType } from '../../../services/apiTypes';
import { Card, CardImage, CardImageContainer, CardText, InnerContainer, MainContainer } from './styles';

type FeedPostProps = {
  display: string;
  modal: boolean;
  setSelectedStory: (i: number) => void;
};

export default function StoriesCards({ display, modal, setSelectedStory }: FeedPostProps) {
  const [cards, setCards] = useState<TimeLineDataType[]>();

  useEffect(() => {
    try {
      api.get(`media/timeline/story`)
        .then(response => {
          if (response && response.status === 200) {
            setCards(response.data)
          }
        })
        .catch(error => {
          console.log(error);
        });
    } catch (error) {
      console.log(error)
    }
  }, [])

  return (
    <MainContainer style={{ display: display, height: modal ? 0 : '100%' }}>
      <InnerContainer>
        {cards && cards.map((card: any, index: number) => (
          <Card key={card.id} onClick={() => setSelectedStory(0)}>
            <CardImageContainer>
              <CardImage src={card.authorAvatarUrl} />
            </CardImageContainer>
            <CardText>{card.authorUsername}</CardText>
          </Card>
        ))}
      </InnerContainer>
    </MainContainer>
  )
}